import { AjaxCall, basicRetryPolicy, getHttpDetails, isHttpRetry } from 'api/basicApi';
import { SettingsInjections } from 'generics/settingsInjections';

// re export
export { basicRetryPolicy, getHttpDetails, isHttpRetry };

////////////////////////////////////////////
// class GenericAPICall
export class GenericAPICall  extends AjaxCall {
  constructor ( command )  {
    super( command )

    const { token } = SettingsInjections.getCredentials();

    this.append( "action", command );
    this.append( "token", token );
  }
}